const API = {
  getCalendarPerformanceChartData: isin =>
    fetch(
      `${process.env.REACT_APP_DATASPAN_API_URL}/funddetails/calendar_year_performance?isin=${isin}`,
    )
      .then(response => response.json())
      .then(data => data),

  getHistoricalPerformanceChartData: (entity, mode) =>
    fetch(
      `${process.env.REACT_APP_DATASPAN_API_URL}/funddetails/historical_performance?entity=${entity}&mode=${mode}`,
    )
      .then(response => response.json())
      .then(data => data),
};

export default API;
